import _resolveAutoOptions from "./helpers/resolveAutoOptions.js";
import _notesHelper from "./helpers/notes.js";
import _getFormatOptions from "./helpers/getFormatOptions.js";
import _calcTc from "./eventGroups/calcTc.js";
import _addIncode from "./special/addIncode.js";
import _applyWindowOffsets from "./special/applyWindowOffsets.js";
import _formats from "../lib/formats.js";
import _defaults from "../lib/defaults.js";
import _encoder from "../profiles/index.js";
const encoder = _encoder;
const defaults = _defaults;
const formats = _formats;
const applyWindowOffsets = _applyWindowOffsets;
const addIncode = _addIncode;
const calcTc = _calcTc;
const getFormatOptions = _getFormatOptions;
const notesHelper = _notesHelper;
const resolveAutoOptions = _resolveAutoOptions;
export default (async function (eventGroups, options = new defaults.options(), qcReport = null) {
  if (encoder[options.profile]) {
    // console.log(JSON.stringify(eventGroups, null, 2));
    //console.log(options);
    let output;
    //Check if EventGroups is an array or single object

    //console.log(eventGroups.length);
    if (!Array.isArray(eventGroups)) {
      eventGroups = [eventGroups];
    }
    eventGroups.forEach(eventGroup => {
      // eventGroup = tcRound(eventGroup, options.frameRate, options.dropFrame);
      eventGroup = calcTc(eventGroup, options.frameRate, options.dropFrame, options.incode);
      eventGroup = addIncode(eventGroup, options);
      eventGroup = applyWindowOffsets(eventGroup, options.window);
      eventGroup = encoder[options.profile].preProcess.encode(eventGroup, options);
    });

    /* Resolve "auto" encoding options from the Event Group metadata (copy options so the caller's job options are not modified) */
    options = {
      ...options,
      formatOptions: resolveAutoOptions(options.formatOptions, eventGroups[0], options.profile)
    };
    if (options.profile === "macCaptionAdvanced" || options.profile === "sceneristAdvanced" || options.profile === "vancData") {
      output = await encoder[options.profile].encode(eventGroups, options, qcReport);
    } else {
      output = await encoder[options.profile].encode(eventGroups[0], options, qcReport);
    }
    output = encoder[options.profile].postProcess.encode(output, options);

    /* Inject cue-level annotation comments (eg. <p>...</p><!--note-->) for
       XML-based profiles when the "Encode Notes" format option is enabled. */
    let targetExt = formats.defaultExtMap[options.profile];
    let isXmlBased = ["xml", "ttml", "dfxp", "itt", "imscr"].indexOf(targetExt) > -1 || options.profile === "broadstreamTtml";
    if (isXmlBased && options.profile !== "fcpXml" && typeof output === "string") {
      let encodingOptions = getFormatOptions(options.formatOptions);
      if (notesHelper.shouldEncodeNotes(encodingOptions)) {
        output = notesHelper.injectXmlCueNotes(output, eventGroups[0].events);
      }
    }
    return output;
  } else {
    throw new Error(`Target profile [${options.profile}] does not exist. Please ensure name matches a supported encoding profile. Profile names are case-sensitive.`);
  }
});